<template>
  <div class="align-center justify-center">
    <p><b>{{ titleCat1 }}</b></p>
    <v-data-table :headers="headersCSG"
        :items="reportDataCat1"
        items-per-page="-1"
        hide-default-footer
        >
        <template v-slot:item.Cat="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.Cat }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.Cat }}</b></span>
        </template>
        <template v-slot:item.RiseIn="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RiseIn }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RiseIn }}</b></span>
        </template>
        <template v-slot:item.RiseOut="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RiseOut }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RiseOut }}</b></span>
        </template>
        <template v-slot:item.RisePremium="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RisePremium }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RisePremium }}</b></span>
        </template>
    </v-data-table>
    <br/><br/>
    <p><b>{{ titleCat2 }}</b></p>
    <v-data-table :headers="headers"
        :items="reportDataCat2"
        items-per-page="-1"
        hide-default-footer
        >
        <template v-slot:item.Cat="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.Cat }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.Cat }}</b></span>
        </template>
        <template v-slot:item.RiseIn="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RiseIn }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RiseIn }}</b></span>
        </template>
        <template v-slot:item.RiseOut="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RiseOut }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RiseOut }}</b></span>
        </template>
        <template v-slot:item.RisePremium="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RisePremium }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RisePremium }}</b></span>
        </template>
    </v-data-table>
    <br/><br/>
    <p><b>{{ titleCat3 }}</b></p>
    <v-data-table :headers="headers"
        :items="reportDataCat3"
        items-per-page="-1"
        hide-default-footer
        >
        <template v-slot:item.Cat="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.Cat }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.Cat }}</b></span>
        </template>
        <template v-slot:item.RiseIn="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RiseIn }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RiseIn }}</b></span>
        </template>
        <template v-slot:item.RiseOut="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RiseOut }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RiseOut }}</b></span>
        </template>
        <template v-slot:item.RisePremium="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RisePremium }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RisePremium }}</b></span>
        </template>
    </v-data-table>
    <br/><br/>
    <p><b>{{ titleCat4 }}</b></p>
    <v-data-table :headers="headersISG"
        :items="reportDataCat4"
        items-per-page="-1"
        hide-default-footer
        >
        <template v-slot:item.Cat="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.Cat }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.Cat }}</b></span>
        </template>
        <template v-slot:item.RiseIn="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RiseIn }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RiseIn }}</b></span>
        </template>
        <template v-slot:item.RiseOut="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RiseOut }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RiseOut }}</b></span>
        </template>
        <template v-slot:item.RisePremium="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RisePremium }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RisePremium }}</b></span>
        </template>
    </v-data-table>
    <br/><br/>
    <p><b>{{ titleCat5 }}</b></p>
    <v-data-table :headers="headersISG"
        :items="reportDataCat5"
        items-per-page="-1"
        hide-default-footer
        >
        <template v-slot:item.Cat="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.Cat }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.Cat }}</b></span>
        </template>
        <template v-slot:item.RiseIn="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RiseIn }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RiseIn }}</b></span>
        </template>
        <template v-slot:item.RiseOut="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RiseOut }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RiseOut }}</b></span>
        </template>
        <template v-slot:item.RisePremium="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RisePremium }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RisePremium }}</b></span>
        </template>
    </v-data-table>
    <br/><br/>
    <p><b>{{ titleCat6 }}</b></p>
    <v-data-table :headers="headers"
        :items="reportDataCat6"
        items-per-page="-1"
        hide-default-footer
        >
        <template v-slot:item.Cat="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.Cat }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.Cat }}</b></span>
        </template>
        <template v-slot:item.RiseIn="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RiseIn }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RiseIn }}</b></span>
        </template>
        <template v-slot:item.RiseOut="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RiseOut }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RiseOut }}</b></span>
        </template>
        <template v-slot:item.RisePremium="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RisePremium }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RisePremium }}</b></span>
        </template>
    </v-data-table>
    <br/><br/>
    <p><b>{{ titleCat7 }}</b></p>
    <v-data-table :headers="headers"
        :items="reportDataCat7"
        items-per-page="-1"
        hide-default-footer
        >
        <template v-slot:item.Cat="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.Cat }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.Cat }}</b></span>
        </template>
        <template v-slot:item.RiseIn="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RiseIn }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RiseIn }}</b></span>
        </template>
        <template v-slot:item.RiseOut="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RiseOut }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RiseOut }}</b></span>
        </template>
        <template v-slot:item.RisePremium="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RisePremium }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RisePremium }}</b></span>
        </template>
    </v-data-table>
    <br/><br/>
    <p><b>{{ titleCat8 }}</b></p>
    <v-data-table :headers="headers"
        :items="reportDataCat8"
        items-per-page="-1"
        hide-default-footer
        >
        <template v-slot:item.Cat="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.Cat }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.Cat }}</b></span>
        </template>
        <template v-slot:item.RiseIn="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RiseIn }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RiseIn }}</b></span>
        </template>
        <template v-slot:item.RiseOut="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RiseOut }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RiseOut }}</b></span>
        </template>
        <template v-slot:item.RisePremium="{ item }">
            <span v-if="item.Cat !== 'RPP'">{{ item.RisePremium }}</span>
            <span v-if="item.Cat === 'RPP'"><b>{{ item.RisePremium }}</b></span>
        </template>
    </v-data-table>
    <br/><br/>
    <p><b>{{ titleCat9 }}</b></p>
    <v-data-table :headers="headersRegion"
        :items="reportDataCat9"
        items-per-page="-1"
        hide-default-footer
        >
        <template v-slot:item.Region="{ item }">
            <span v-if="item.Region !== 'TOTAL'">{{ item.Region }}</span>
            <span v-if="item.Region === 'TOTAL'"><b>{{ item.Region }}</b></span>
        </template>
        <template v-slot:item.PartnersIn="{ item }">
            <span v-if="item.Region !== 'TOTAL'">{{ item.PartnersIn }}</span>
            <span v-if="item.Region === 'TOTAL'"><b>{{ item.PartnersIn }}</b></span>
        </template>
        <template v-slot:item.PartnersOut="{ item }">
            <span v-if="item.Region !== 'TOTAL'">{{ item.PartnersOut }}</span>
            <span v-if="item.Region === 'TOTAL'"><b>{{ item.PartnersOut }}</b></span>
        </template>
        <template v-slot:item.UnitsIn="{ item }">
            <span v-if="item.Region !== 'TOTAL'">{{ item.UnitsIn }}</span>
            <span v-if="item.Region === 'TOTAL'"><b>{{ item.UnitsIn }}</b></span>
        </template>
        <template v-slot:item.UnitsOut="{ item }">
            <span v-if="item.Region !== 'TOTAL'">{{ item.UnitsOut }}</span>
            <span v-if="item.Region === 'TOTAL'"><b>{{ item.UnitsOut }}</b></span>
        </template>
        <template v-slot:item.RevenueIn="{ item }">
            <span v-if="item.Region !== 'TOTAL'">{{ item.RevenueIn }}</span>
            <span v-if="item.Region === 'TOTAL'"><b>{{ item.RevenueIn }}</b></span>
        </template>
        <template v-slot:item.RevenueOut="{ item }">
            <span v-if="item.Region !== 'TOTAL'">{{ item.RevenueOut }}</span>
            <span v-if="item.Region === 'TOTAL'"><b>{{ item.RevenueOut }}</b></span>
        </template>
    </v-data-table>
  </div>
</template>

<script setup>

import { ref, watch, onMounted } from 'vue'

const props = defineProps({
  report: { type: Array}
})

const headers = [
  { key: 'Cat', title: 'Category', align: 'start', sortable: false},
  { key: 'RiseIn', title: 'RISE In', align: 'end', sortable: false},
  { key: 'RiseOut', title: 'RISE Out', align: 'end', sortable: false},
  { key: 'RisePremium', title: 'RISE Premium', align: 'end', sortable: false}
]
const headersCSG = [
  { key: 'Cat', title: 'Category', align: 'start', sortable: false},
  { key: 'RiseIn', title: 'RISE In', align: 'end', sortable: false},
  { key: 'RiseOut', title: 'RISE Out', align: 'end', sortable: false},
  { key: 'RisePremium', title: 'RISE Premium', align: 'end', sortable: false},
  { key: 'FirstPurchase', title: 'First Purchase', align: 'end', sortable: false},
  { key: 'PrecisionBonus', title: 'Precision Bonus', align: 'end', sortable: false}
]
const headersISG = [
  { key: 'Cat', title: 'Category', align: 'start', sortable: false},
  { key: 'RiseIn', title: 'RISE In', align: 'end', sortable: false},
  { key: 'RiseOut', title: 'RISE Out', align: 'end', sortable: false},
  { key: 'RisePremium', title: 'RISE Premium', align: 'end', sortable: false},
  { key: 'FirstPurchase', title: 'First Purchase', align: 'end', sortable: false}
]
const headersRegion = [
  { key: 'Region', title: 'Region', align: 'start', sortable: false},
  { key: 'PartnersIn', title: 'Partners In', align: 'end', sortable: false},
  { key: 'PartnersOut', title: 'Partners Out', align: 'end', sortable: false},
  { key: 'UnitsIn', title: 'Units In', align: 'end', sortable: false},
  { key: 'UnitsOut', title: 'Units Out', align: 'end', sortable: false},
  { key: 'RevenueIn', title: 'Revenue In', align: 'end', sortable: false},
  { key: 'RevenueOut', title: 'Revenue Out', align: 'end', sortable: false},
]
const titleCat1 = ref('')
const titleCat2 = ref('')
const titleCat3 = ref('')
const titleCat4 = ref('')
const titleCat5 = ref('')
const titleCat6 = ref('')
const titleCat7 = ref('')
const titleCat8 = ref('')
const titleCat9 = ref('')
const reportDataCat1 = ref([])
const reportDataCat2 = ref([])
const reportDataCat3 = ref([])
const reportDataCat4 = ref([])
const reportDataCat5 = ref([])
const reportDataCat6 = ref([])
const reportDataCat7 = ref([])
const reportDataCat8 = ref([])
const reportDataCat9 = ref([])

watch(
  props.report,
  (data) => {
    
    let set = data.filter((d) => { return d.Id == 1 })[0];
    
    titleCat1.value = set.Cat + ' in ' + set.Quarter
    reportDataCat1.value.push({'Cat': 'Units', 'RiseIn': set.RiseIn_Units, 'RiseOut': set.RiseOut_Units, 'RisePremium': set.RisePremium_Units, 'FirstPurchase': set.RiseFirstPurchase_Units, 'PrecisionBonus': set.RisePrecisionBonus_Units})
    reportDataCat1.value.push({'Cat': 'Partners', 'RiseIn': set.RiseIn_Partners, 'RiseOut': set.RiseOut_Partners, 'RisePremium': set.RisePremium_Partners, 'FirstPurchase': set.RiseFirstPurchase_Partners, 'PrecisionBonus': set.RisePrecisionBonus_Partners})
    reportDataCat1.value.push({'Cat': 'Revenue', 'RiseIn': set.RiseIn_Revenue, 'RiseOut': set.RiseOut_Revenue, 'RisePremium': set.RisePremium_Revenue, 'FirstPurchase': set.RiseFirstPurchase_Revenue, 'PrecisionBonus': set.RisePrecisionBonus_Revenue})
    reportDataCat1.value.push({'Cat': 'RPP', 'RiseIn': set.RiseIn_RPP, 'RiseOut': set.RiseOut_RPP, 'RisePremium': set.RisePremium_RPP, 'FirstPurchase': '', 'PrecisionBonus': ''})
  
    set = data.filter((d) => { return d.Id == 2 })[0];
    
    titleCat2.value = set.Cat + ' in ' + set.Quarter
    reportDataCat2.value.push({'Cat': 'Units', 'RiseIn': set.RiseIn_Units, 'RiseOut': set.RiseOut_Units, 'RisePremium': set.RisePremium_Units})
    reportDataCat2.value.push({'Cat': 'Partners', 'RiseIn': set.RiseIn_Partners, 'RiseOut': set.RiseOut_Partners, 'RisePremium': set.RisePremium_Partners})
    reportDataCat2.value.push({'Cat': 'Revenue', 'RiseIn': set.RiseIn_Revenue, 'RiseOut': set.RiseOut_Revenue, 'RisePremium': set.RisePremium_Revenue})
    reportDataCat2.value.push({'Cat': 'RPP', 'RiseIn': set.RiseIn_RPP, 'RiseOut': set.RiseOut_RPP, 'RisePremium': set.RisePremium_RPP})

    set = data.filter((d) => { return d.Id == 3 })[0];
    
    titleCat3.value = set.Cat + ' in ' + set.Quarter
    reportDataCat3.value.push({'Cat': 'Units', 'RiseIn': set.RiseIn_Units, 'RiseOut': set.RiseOut_Units, 'RisePremium': set.RisePremium_Units})
    reportDataCat3.value.push({'Cat': 'Partners', 'RiseIn': set.RiseIn_Partners, 'RiseOut': set.RiseOut_Partners, 'RisePremium': set.RisePremium_Partners})
    reportDataCat3.value.push({'Cat': 'Revenue', 'RiseIn': set.RiseIn_Revenue, 'RiseOut': set.RiseOut_Revenue, 'RisePremium': set.RisePremium_Revenue})
    reportDataCat3.value.push({'Cat': 'RPP', 'RiseIn': set.RiseIn_RPP, 'RiseOut': set.RiseOut_RPP, 'RisePremium': set.RisePremium_RPP})
  
    set = data.filter((d) => { return d.Id == 4 })[0];
    
    titleCat4.value = set.Cat + ' in ' + set.Quarter
    reportDataCat4.value.push({'Cat': 'Units', 'RiseIn': set.RiseIn_Units, 'RiseOut': set.RiseOut_Units, 'RisePremium': set.RisePremium_Units, 'FirstPurchase': set.RiseFirstPurchase_Units})
    reportDataCat4.value.push({'Cat': 'Partners', 'RiseIn': set.RiseIn_Partners, 'RiseOut': set.RiseOut_Partners, 'RisePremium': set.RisePremium_Partners, 'FirstPurchase': set.RiseFirstPurchase_Partners})
    reportDataCat4.value.push({'Cat': 'Revenue', 'RiseIn': set.RiseIn_Revenue, 'RiseOut': set.RiseOut_Revenue, 'RisePremium': set.RisePremium_Revenue, 'FirstPurchase': set.RiseFirstPurchase_Revenue})
    reportDataCat4.value.push({'Cat': 'RPP', 'RiseIn': set.RiseIn_RPP, 'RiseOut': set.RiseOut_RPP, 'RisePremium': set.RisePremium_RPP, 'FirstPurchase': ''})
  
    set = data.filter((d) => { return d.Id == 5 })[0];
    
    titleCat5.value = set.Cat + ' in ' + set.Quarter
    reportDataCat5.value.push({'Cat': 'Units', 'RiseIn': set.RiseIn_Units, 'RiseOut': set.RiseOut_Units, 'RisePremium': set.RisePremium_Units, 'FirstPurchase': set.RiseFirstPurchase_Units})
    reportDataCat5.value.push({'Cat': 'Partners', 'RiseIn': set.RiseIn_Partners, 'RiseOut': set.RiseOut_Partners, 'RisePremium': set.RisePremium_Partners, 'FirstPurchase': set.RiseFirstPurchase_Partners})
    reportDataCat5.value.push({'Cat': 'Revenue', 'RiseIn': set.RiseIn_Revenue, 'RiseOut': set.RiseOut_Revenue, 'RisePremium': set.RisePremium_Revenue, 'FirstPurchase': set.RiseFirstPurchase_Revenue})
    reportDataCat5.value.push({'Cat': 'RPP', 'RiseIn': set.RiseIn_RPP, 'RiseOut': set.RiseOut_RPP, 'RisePremium': set.RisePremium_RPP, 'FirstPurchase': ''})
  
    set = data.filter((d) => { return d.Id == 6 })[0];
    
    titleCat6.value = set.Cat + ' in ' + set.Quarter
    reportDataCat6.value.push({'Cat': 'Units', 'RiseIn': set.RiseIn_Units, 'RiseOut': set.RiseOut_Units, 'RisePremium': set.RisePremium_Units})
    reportDataCat6.value.push({'Cat': 'Partners', 'RiseIn': set.RiseIn_Partners, 'RiseOut': set.RiseOut_Partners, 'RisePremium': set.RisePremium_Partners})
    reportDataCat6.value.push({'Cat': 'Revenue', 'RiseIn': set.RiseIn_Revenue, 'RiseOut': set.RiseOut_Revenue, 'RisePremium': set.RisePremium_Revenue})
    reportDataCat6.value.push({'Cat': 'RPP', 'RiseIn': set.RiseIn_RPP, 'RiseOut': set.RiseOut_RPP, 'RisePremium': set.RisePremium_RPP})

    set = data.filter((d) => { return d.Id == 7 })[0];
    
    titleCat7.value = set.Cat + ' in ' + set.Quarter
    reportDataCat7.value.push({'Cat': 'Units', 'RiseIn': set.RiseIn_Units, 'RiseOut': set.RiseOut_Units, 'RisePremium': set.RisePremium_Units})
    reportDataCat7.value.push({'Cat': 'Partners', 'RiseIn': set.RiseIn_Partners, 'RiseOut': set.RiseOut_Partners, 'RisePremium': set.RisePremium_Partners})
    reportDataCat7.value.push({'Cat': 'Revenue', 'RiseIn': set.RiseIn_Revenue, 'RiseOut': set.RiseOut_Revenue, 'RisePremium': set.RisePremium_Revenue})
    reportDataCat7.value.push({'Cat': 'RPP', 'RiseIn': set.RiseIn_RPP, 'RiseOut': set.RiseOut_RPP, 'RisePremium': set.RisePremium_RPP})
  
    set = data.filter((d) => { return d.Id == 8 })[0];
    
    titleCat8.value = set.Cat + ' in ' + set.Quarter
    reportDataCat8.value.push({'Cat': 'Units', 'RiseIn': set.RiseIn_Units, 'RiseOut': set.RiseOut_Units, 'RisePremium': set.RisePremium_Units})
    reportDataCat8.value.push({'Cat': 'Partners', 'RiseIn': set.RiseIn_Partners, 'RiseOut': set.RiseOut_Partners, 'RisePremium': set.RisePremium_Partners})
    reportDataCat8.value.push({'Cat': 'Revenue', 'RiseIn': set.RiseIn_Revenue, 'RiseOut': set.RiseOut_Revenue, 'RisePremium': set.RisePremium_Revenue})
    reportDataCat8.value.push({'Cat': 'RPP', 'RiseIn': set.RiseIn_RPP, 'RiseOut': set.RiseOut_RPP, 'RisePremium': set.RisePremium_RPP})
  
    set = data.filter((d) => { return d.Id == 9 });
    
    titleCat9.value = set[0].Cat + ' in ' + set[0].Quarter

    set.forEach(e => {
      reportDataCat9.value.push({
        'Region': e.Region,
        'PartnersIn': e.RiseIn_Partners,
        'PartnersOut': e.RiseOut_Partners,
        'UnitsIn': e.RiseIn_Units,
        'UnitsOut': e.RiseOut_Units,
        'RevenueIn': e.RiseIn_Revenue,
        'RevenueOut': e.RiseOut_Revenue
      })      
    });

  },
  {immediate:true}
) 

onMounted(() => {
})


</script>

<style scoped>

</style>